(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  // Collection view switcher: buttons in the facets bar (snippets/facets-bar.liquid)
  // toggle <html data-collection-view>; the choice is remembered in localStorage
  // and applied before paint by the section's inline script.
  (function () {
    var KEY = 'collection_view';
    function sync() {
      var view = document.documentElement.getAttribute('data-collection-view');
      document.querySelectorAll('[data-collection-view-btn]').forEach(function (btn) {
        btn.setAttribute('aria-pressed', btn.getAttribute('data-collection-view-btn') === view ? 'true' : 'false');
      });
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-collection-view-btn]');
      if (!btn) return;
      var view = btn.getAttribute('data-collection-view-btn');
      document.documentElement.setAttribute('data-collection-view', view);
      try { localStorage.setItem(KEY, view); } catch (err) {}
      sync();
      // Column widths changed: let lazysizes / carousels re-measure.
      window.dispatchEvent(new Event('resize'));
    });
    document.addEventListener('collection:rendered', sync);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', sync);
    } else {
      sync();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["overlay-promo"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initPromoPopup(root) {
    if (root.dataset.promoInit) return;
    root.dataset.promoInit = '1';

    var sectionId = root.dataset.sectionId;
    var storageKey = 'ns-promo-popup:' + sectionId;
    var delay = parseInt(root.dataset.delay, 10) || 0;
    var frequency = root.dataset.frequency || 'days';
    var days = parseInt(root.dataset.frequencyDays, 10) || 7;
    var designMode = root.dataset.designMode === 'true';
    var timer = null;

    function wasDismissed() {
      try {
        if (frequency === 'always') return false;
        if (frequency === 'session') return sessionStorage.getItem(storageKey) === '1';
        var ts = parseInt(localStorage.getItem(storageKey), 10);
        if (!ts) return false;
        return (Date.now() - ts) < days * 86400000;
      } catch (e) {
        return false;
      }
    }

    function rememberDismiss() {
      try {
        if (frequency === 'session') sessionStorage.setItem(storageKey, '1');
        else if (frequency === 'days') localStorage.setItem(storageKey, String(Date.now()));
      } catch (e) { /* storage unavailable */ }
    }

    // A visit from a Next Step Club invite link gets the referral popup
    // (snippets/loyalty-referral.liquid): no promo on top of it or right after it.
    // Not remembered as dismissed, so the promo shows on a later visit.
    function loyaltyReferralVisit() {
      if (document.documentElement.classList.contains('loyalty-referral-open')) return true;
      try {
        return !!document.querySelector('loyalty-referral') && !!sessionStorage.getItem('loyalty:ref');
      } catch (e) {
        return false;
      }
    }

    function open() {
      if (!designMode && loyaltyReferralVisit()) return;
      root.classList.add('is-open');
      document.documentElement.classList.add('promo-popup-open');
    }

    function close(remember) {
      root.classList.remove('is-open');
      document.documentElement.classList.remove('promo-popup-open');
      if (remember && !designMode) rememberDismiss();
    }

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-promo-close]')) close(true);
      if (e.target.closest('.promo-popup__cta') || e.target.closest('a.promo-popup__media-link')) close(true);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) close(true);
    });

    if (designMode) {
      document.addEventListener('shopify:section:select', function (e) {
        if (e.detail && e.detail.sectionId === sectionId) open();
      });
      document.addEventListener('shopify:section:deselect', function (e) {
        if (e.detail && e.detail.sectionId === sectionId) close(false);
      });
      return;
    }

    if (wasDismissed()) return;

    // The browser stops looking for LCP at the first input. Opening on a timer
    // before that turns the popup text into a ~10s LCP, so a visitor who hasn't
    // touched the page yet gets it on their first scroll or key press instead.
    // Not on pointerdown: it would land on top of whatever they were tapping.
    var hasInteracted = false;
    var firstInputEvents = ['pointerdown', 'wheel', 'touchmove', 'keydown'];
    var openOnInputEvents = ['wheel', 'touchmove', 'keydown'];
    function markInteracted() {
      hasInteracted = true;
      firstInputEvents.forEach(function (type) { window.removeEventListener(type, markInteracted); });
    }
    function openOnInput() {
      openOnInputEvents.forEach(function (type) { window.removeEventListener(type, openOnInput); });
      open();
    }
    firstInputEvents.forEach(function (type) {
      window.addEventListener(type, markInteracted, { passive: true });
    });
    timer = setTimeout(function () {
      if (hasInteracted) {
        open();
        return;
      }
      openOnInputEvents.forEach(function (type) {
        window.addEventListener(type, openOnInput, { passive: true });
      });
    }, delay * 1000);
    window.addEventListener('pagehide', function () { if (timer) clearTimeout(timer); });
  }

  function boot() {
    document.querySelectorAll('[data-promo-popup]').forEach(initPromoPopup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
